export const UserGroupGetters = {
  userGroups: state => state.groups,
}
